'use client';

import { useEffect, useRef } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/src/components/ui/card';
import { Button } from '@/src/components/ui/button';
import { logger } from '@/src/logging/logger';
import './globals.css';

export default function GlobalError({
  error,
  reset,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  unstable_retry: () => void;
}) {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    logger.error('Unhandled root layout error', error, { digest: error.digest });
    headingRef.current?.focus();
  }, [error]);

  return (
    <html lang="en">
      <body>
        <title>SparkOne recovery</title>
        <main className="grid min-h-screen place-items-center bg-background p-6">
          <section aria-labelledby="global-error-title" className="w-full max-w-md">
            <Card role="alert" aria-labelledby="global-error-title" className="border-destructive/30 bg-destructive/5">
              <CardHeader>
                <CardTitle>
                  <h1 id="global-error-title" ref={headingRef} tabIndex={-1}>
                    SparkOne needs to recover
                  </h1>
                </CardTitle>
                <CardDescription>
                  The application shell hit an unexpected problem. Try loading it again, or reset the application view if the problem continues.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  <Button type="button" onClick={unstable_retry}>
                    Try again
                  </Button>
                  <Button type="button" variant="outline" onClick={reset}>
                    Reset application
                  </Button>
                </div>
              </CardContent>
            </Card>
          </section>
        </main>
      </body>
    </html>
  );
}
